import session from '../../../../share/session';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import { PHASE } from './constants';
import { REQUEST_STATUS_COMPLETED } from '../../../../share/util/api/polling';

/**
 * 終了処理メソッド
 */
export async function executeApi(self, isSendIot) {
  try {
    self.phase = PHASE.EXECUTION;
    self.isLoading = true;
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'execute',
        is_dll_reuse: isSendIot
      },
      // エラー発生のコールバック
      (errorType) => { errorType; self.showError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      (result) => { self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      (result) => { self.validateErrorResult(result); },
    );
    if (response) {
      switch (response.data.status) {
        case REQUEST_STATUS_COMPLETED:
          self.phase = PHASE.SUCCESS;
          await self.exitProcess();
          return;
        default:
          await self.showError();
          break;
      }
    }
  }
  finally {
    self.isLoading = false;
  }
}